// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { InteractiveProduct, Product } from '@coveo/headless/commerce'
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

export interface CoveoProductModel {
    title: string;
    category: [];
    brandName: string;
    shortDescription: string;
    productNumber: string;
    manufacturerItem: string;
    availability: [];
    urlSegment: string;
    imageAltText: string;
    mediumImagePath: string;
    smallImagePath: string;
    pricing: ProductPriceDto | null;
    variantTypeId: string | null;
    canAddToCart: boolean;
    quoteRequired: boolean;
    minimumOrderQty: string;
    allowZeroPricing: boolean;
    unitListPrice: number;
    vendorAuthRequiredList: string;
    vendorAuthRequiredLink: string;
    unitofmeasure: string;
    productId: string;
    canonicalUrl: string;
    featureBullets1to3: string;
    classificatioN_CODE: string | null;
    saleType: string | null;
    onSaleNow: string | null;
    brandUrlSegment: string;
    isNewProduct: string | null;
    showAuthorizationRequired: boolean;
    responseId: string;
    position: number;
    interactiveProduct? : InteractiveProduct | null;
    modelNumber: string;
    logicBroker: string;    
}

export interface CoveoBrandModel {
    logoSmallImagePath: string;
    logoImageAltText: string;
    detailPagePath: string;
    name: string;
}

export const mapCoveoBrand = (result: Product): CoveoBrandModel => ({
    logoSmallImagePath: result.additionalFields?.brandlogosmallimagepath as string,
    logoImageAltText: result.additionalFields?.logoimagealttext as string,
    detailPagePath: result.additionalFields?.detailpagepath as string,
    name: result.additionalFields?.ec_brand as string,
});

export interface CoveoProductInfo {
    productId: string;
    qtyOrdered: number;
    unitOfMeasure: string;
    pricing?: ProductPriceDto;
    // inventory?: ProductInventoryDto;
    failedToLoadPricing?: true;
    failedToLoadInventory?: true;
    productDetailPath: string;
}
export const mapCoveoProductInfo = (result: CoveoProductModel): CoveoProductInfo => ({
    productId: result.productId,
    qtyOrdered: Math.max(Number(result.minimumOrderQty), 1),
    unitOfMeasure: result.unitofmeasure,
    productDetailPath: `/Product/${result.urlSegment}`,
    pricing: result.pricing as ProductPriceDto,
    // inventory: result.inventory,
});
